<template>
	<div id="app">
		<component :is="layout">
			<router-view />
		</component>
		<Alert></Alert>
		<IncomingCall v-if="caller"></IncomingCall>
		<Call></Call>
		<MessageAudio></MessageAudio>
		<NotificationAudio></NotificationAudio>
		<div ref="height" class="window-height"></div>
		<div ref="width" class="window-width"></div>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Alert from "@/components/Alert";
import IncomingCall from "@/components/IncomingCall";
import Call from "@/components/Call";
import MessageAudio from "@/components/Audio/Message";
import NotificationAudio from "@/components/Audio/Notification";
const defaultLayout = "default";
export default {
	components: {
		Alert,
		IncomingCall,
		MessageAudio,
		NotificationAudio,
		Call,
	},
	metaInfo: {
		title: "Home",
		titleTemplate: "%s | MyDoc",
		meta: [{ name: "apple-mobile-web-app-capable", content: "yes" }],
		link: [
			{
				href: "/android-chrome-512x512.png",
				sizes: "512x512",
				rel: "apple-touch-icon",
			},
			{
				href: "/android-chrome-192x192.png",
				sizes: "192x192",
				rel: "apple-touch-icon",
			},
		],
	},
	computed: {
		...mapGetters({
			caller: "call/callerId",
			authedUser: "auth/user",
			authLocale: "auth/locale",
			authType: "auth/type",
			refreshHeight: "app/refreshHeight",
		}),
		layout() {
			return (this.$route.meta.layout || defaultLayout) + "-layout";
		},
	},
	watch: {
		refreshHeight() {
			this.setHeight(this.$refs.height.clientHeight - 10);
			this.setWidth(this.$refs.width.clientWidth);
			setTimeout(() => {
				this.setHeight(this.$refs.height.clientHeight);
				this.setWidth(this.$refs.width.clientWidth);
			}, 100);
		},
		authedUser() {
			if (!this.authedUser) {
				console.log("not authed");
				return;
			}
			console.log("authed and starting");
			this.startOneSignalServiceWorker();
		},
		authLocale(locale) {
			this.$i18n.locale = locale;
			this.$moment.locale(locale);
		},
	},
	created() {
		this.appInit();
	},
	mounted() {
		this.$nextTick(() => {
			this.setLocale(localStorage.getItem("locale"));
			this.$i18n.locale = localStorage.getItem("locale");
			this.$moment.locale(localStorage.getItem("locale"));
			window.addEventListener("resize", () => {
				this.setHeight(this.$refs.height.clientHeight);
				this.setWidth(this.$refs.width.clientWidth);
			});
		});
		if (!this.authedUser) {
			return this.setupApp();
		}
		// start service worker for logged in user
		this.startOneSignalServiceWorker();
		this.checkTokenValidity()
			.then(() => {
				this.setupApp();
			})
			.catch((err) => {
				if (err.response && err.response.status === 401) {
					this.$store.commit("auth/setToken", null);
					this.$store.commit("auth/setUser", null);
					this.$cookie.delete("session");
					this.$router.push({ name: "Login" });
				}
			});
	},
	methods: {
		setupApp() {
			this.init();
			if (this.authType === "Patient") {
				this.notificationInit();
			}
			this.staticserviceInit();
			this.servicecatInit();
			this.servicetplInit();
			// this.evidenceInit()
			// this.conditionInit()
			this.labtestInit();
			this.specialitiesInit();
			this.patientLogTypeInit();
			// this.diseaseInit()
		},
		...mapActions({
			notificationInit: "notification/init",
			staticserviceInit: "staticservice/init",
			servicecatInit: "servicecat/init",
			servicetplInit: "servicetpl/init",
			labtestInit: "labtest/init",
			specialitiesInit: "speciality/init",
			patientLogTypeInit: "patientLogType/init",
		}),
		...mapMutations({
			appInit: "app/init",
			setHeight: "app/setHeight",
			setWidth: "app/setWidth",
			setLocale: "auth/setLocale",
		}),
		init() {
			this.setHeight(this.$refs.height.clientHeight);
			this.setWidth(this.$refs.width.clientWidth);
		},
		async checkTokenValidity() {
			return this.axios.get("/api/auth/user");
		},
		subscribeUser() {
			return window.OneSignal.getUserId((userId) => {
				const params = {
					onesignal_user_id: userId,
				};
				this.axios
					.post("/api/notifications/onesignal", params)
					.then((response) => {
						console.log("save-subscription", response);
					})
					.catch(function(error) {
						console.error(error);
					});
			});
		},
		startOneSignalServiceWorker() {
			window.OneSignal.SERVICE_WORKER_PARAM = { scope: "/" };
			window.OneSignal.push(() => {
				window.OneSignal.on("subscriptionChange", (isSubscribed) => {
					if (isSubscribed) {
						this.subscribeUser().then((result) => {
							console.log(
								"user subscription changed to subscribed subscription call result ->",
								result
							);
						});
					}
				});
				window.OneSignal.isPushNotificationsEnabled((isEnabled) => {
					if (isEnabled) {
						this.subscribeUser().then((result) => {
							console.log(
								"push notifications enabled -> subscription call result ->",
								result
							);
						});
					} else {
						console.log("Push notifications are not enabled yet.");
						// window.OneSignal.registerForPushNotifications()
						console.log("here we are but no prompt");
						window.OneSignal.showSlidedownPrompt().then(
							(result) => {
								console.log("slide down result", result);
							}
						);
					}
				});
			});
		},
	},
};
</script>
<style lang="scss">
$theme-colors: (
	primary: #3c88ff,
);
@import "~bootstrap";
@each $breakpoint in map-keys($grid-breakpoints) {
	@include media-breakpoint-up($breakpoint) {
		$infix: breakpoint-infix($breakpoint, $grid-breakpoints);

		.border#{$infix}-top {
			border-top: $border-width solid $border-color !important;
		}
		.border#{$infix}-right {
			border-right: $border-width solid $border-color !important;
		}
		.border#{$infix}-bottom {
			border-bottom: $border-width solid $border-color !important;
		}
		.border#{$infix}-left {
			border-left: $border-width solid $border-color !important;
		}

		.border#{$infix}-top-0 {
			border-top: 0 !important;
		}
		.border#{$infix}-right-0 {
			border-right: 0 !important;
		}
		.border#{$infix}-bottom-0 {
			border-bottom: 0 !important;
		}
		.border#{$infix}-left-0 {
			border-left: 0 !important;
		}

		.border#{$infix}-x {
			border-left: $border-width solid $border-color !important;
			border-right: $border-width solid $border-color !important;
		}

		.border#{$infix}-y {
			border-top: $border-width solid $border-color !important;
			border-bottom: $border-width solid $border-color !important;
		}
	}
}
</style>
